export function isKeyboardClickKey(key: string) {
    return key === "Space" || key === "Enter";
}

export function clamp(value: number, min?: number, max?: number) {
    value = min != null && value < min ? min : value;
    return max != null && value > max ? max : value;
}

export function isValidNumber(value: any) {
    return value != null && !Number.isNaN(value);
}

export function toMaxPrecision(value: number, maxPrecision: number) {
    const scaleFactor = Math.pow(10, maxPrecision);
    return Math.round(value * scaleFactor) / scaleFactor;
}
